import { MediaDevices } from "./camera-detection-constants";

const InitCameraDetection = async (
    setHasCamera: (hasCamera: boolean) => void,
    setIsLoading: (isLoading: boolean) => void
) => {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        setHasCamera(
            !!devices.filter(d => d.kind === MediaDevices.Video).length
        );
    } catch (error) {
        setHasCamera(false);
    }
    setIsLoading(false);
};

export default InitCameraDetection;
